module.exports = __webpack_public_path__ + "static/media/le-burger-royale-dt.71452a72.jpg";